// extracted by mini-css-extract-plugin
module.exports = {"root":"section_root__1ukbH","titleButton":"section_titleButton__2oV5a","pageTitle":"section_pageTitle__1QOlh","main":"section_main__vF1tv","active":"section_active__CXwTd"};